import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output } from '@angular/core';
import { IVoidsItem } from '../../models/shift';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ShiftsUpdateItemsService } from '../../services/shifts-update-items.service';
import { Subscription } from 'rxjs/Subscription';
import { CustomSyncValidators } from '../../../../../shared/validators/sync-validators';
import { UtilityFunctions } from '../../../../../shared/utils/utility-functions';
import { ISubmittedData } from '../form-core-shift/form-core-shift.component';
import { animate, style, transition, trigger } from '@angular/animations';
import { IBrokenCon, InitializerService } from '../../../../../initialiaze/services/initializer.service';
import { Observable } from 'rxjs/Observable';
import { ToasterService } from 'angular2-toaster';
import { IMainRecon } from '../../../../../initialiaze/models/main-recon';

@Component({
  selector: 'daccs-form-voids-recon',
  templateUrl: './form-voids-recon.component.html',
  styleUrls: ['./form-voids-recon.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({opacity: 0}),
        animate(500, style({opacity: 1}))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(500, style({opacity: 0}))
      ])
    ])
  ]
})
export class FormVoidsReconComponent implements OnChanges, OnDestroy {

  @Input() public voidsData: Array<IVoidsItem>;
  @Input() public mongoId: string;
  @Output() dirtyVoidsForm = new EventEmitter();

  public rollingAmmount = 0;
  public voidsReconForm: FormGroup;
  public loaderImg = 'assets/images/ui/loader.svg';
  public busy$: Observable<boolean>;
  public conbroken$: Observable<IBrokenCon>;
  public mainRecon$: Observable<IMainRecon>;

  private _formSub: Subscription;

  constructor(private _fb: FormBuilder,
              private _settingsService: InitializerService,
              private _toasterService: ToasterService,
              private _initializerService: InitializerService,
              private _reconItemsService: ShiftsUpdateItemsService) {
    this.busy$ = this._settingsService.serverIsRunning$;
    this.conbroken$ = this._initializerService.conbroken$;
    this.mainRecon$ = this._initializerService.mainRecon$;
  }

  public onSubmit(body: ISubmittedData) {
    this._settingsService.serverIsRunning$.next(true);
    this.dirtyVoidsForm.emit(false);
    this._reconItemsService.updateReconItemByShift(body, this.mongoId)
      .subscribe(
        () => {
          this._settingsService.serverIsRunning$.next(false);
        },
        err => {
          this._settingsService.serverIsRunning$.next(false);
          this._toasterService.pop('error', `Error: ${err.status}`,
            `Message: ${err.statusText}`);
          console.log(err);
        }
      );
  }

  // necessary for AOT compliation to avoid Abstract control err
  public getFormArrayControls(form: FormGroup, cntrl: string): FormControl[] {
    return form.get(cntrl)['controls'];
  }

  public addInputRow(): void {
    const arrayControl: FormArray = this.voidsReconForm.get(`voids`) as FormArray;
    const newGroup = this._fb.group({
      ref_number: [null, Validators.required],
      cashier_name: [null, Validators.required],
      manager_name: [null, Validators.required],
      manager_code: [null, Validators.required],
      description: [null, Validators.required],
      amount: [null, [Validators.required, CustomSyncValidators.integerValidator]],
    });
    arrayControl.push(newGroup);
  }

  public delPackageInput(index: number): void {
    this.voidsReconForm.controls['voids'].markAsDirty();
    const arrayControl: FormArray = this.voidsReconForm.get(`voids`) as FormArray;
    arrayControl.removeAt(index);
  }

  public getIsNan(val: any) {
    return isNaN(val) ? '----' : (Math.round((val ) * 100) / 100);
  }

  ngOnChanges(): void {

    this.rollingAmmount = 0;

    if (this.voidsData) {

      this.voidsReconForm = this._fb.group({
        voids: this._fb.array([]),
      });

      if (this._formSub) {
        this._formSub.unsubscribe();
      }
      this._formSub = this.voidsReconForm.valueChanges.subscribe((formData: any) => {
        this.rollingAmmount = UtilityFunctions.addUpAmounts(formData.voids);
        this.dirtyVoidsForm.emit(this.voidsReconForm.dirty);
      });

      const voidsArrayControl: FormArray = this.voidsReconForm.get(`voids`) as FormArray;
      this.voidsData.forEach((item: IVoidsItem) => {
        const newGroup = this._fb.group({
          ref_number: [item.ref_number, Validators.required],
          cashier_name: [item.cashier_name, Validators.required],
          manager_name: [item.manager_name, Validators.required],
          manager_code: [item.manager_code, Validators.required],
          description: [item.description, Validators.required],
          amount: [item.amount, [Validators.required, CustomSyncValidators.integerValidator]],
        });
        voidsArrayControl.push(newGroup);
      });
    }
  }

  ngOnDestroy(): void {
    if (this._formSub) {
      this._formSub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/views/daily-recon/shifts-recon/components/form-voids-recon/form-voids-recon.component.ts